import { QuestionCustomized } from 'Interfaces/Ticket/Ticket';

const addRequireCommentToSubCategory = (
    subCategories: QuestionCustomized[],
    requireComment: boolean,
): QuestionCustomized[] => {
    return subCategories.map((subCategory) => {
        return {
            ...subCategory,
            requiresComments: requireComment,
        };
    });
};

export default addRequireCommentToSubCategory;
